import React from "react";

const Header = () => {
  return (
    <>
      <div className="bg-white h-16 p-3 pl-10">
        {/* input */}
        <div className="flex justify-between">
          {/* flex item1 */}
          <div className="flex w-[40%] justify-evenly">
            <div className="relative">
              <input
                type="text"
                placeholder="Search"
                className="w-[488px] pl-8 pr-12 py-2 rounded-md border-gray-300 focus:outline-none focus:ring focus:border-blue-300 bg-[#F4F3F6]"
              />
              <svg
                width="20"
                height="20"
                viewBox="0 0 27 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="absolute top-0 left-[450px] h-full flex items-center"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M19.3389 17.4129L26.6015 24.6758C26.8568 24.9312 27.0001 25.2776 27 25.6388C26.9999 25.9999 26.8563 26.3462 26.6008 26.6015C26.3454 26.8568 25.999 27.0001 25.6379 27C25.2767 26.9999 24.9304 26.8563 24.6752 26.6008L17.4125 19.338C15.2414 21.0196 12.5112 21.811 9.77742 21.5511C7.04359 21.2912 4.51146 19.9995 2.69613 17.9389C0.880803 15.8783 -0.0813541 13.2035 0.00539479 10.4586C0.0921436 7.71377 1.22128 5.10506 3.1631 3.16318C5.10493 1.22131 7.71357 0.0921459 10.4584 0.00539492C13.2031 -0.0813561 15.8779 0.880824 17.9384 2.6962C19.999 4.51157 21.2906 7.04377 21.5505 9.77766C21.8104 12.5116 21.0191 15.2418 19.3375 17.4129H19.3389ZM10.8005 18.8992C12.9487 18.8992 15.0088 18.0459 16.5278 16.5269C18.0468 15.0079 18.9001 12.9476 18.9001 10.7994C18.9001 8.65121 18.0468 6.59099 16.5278 5.07198C15.0088 3.55297 12.9487 2.6996 10.8005 2.6996C8.65235 2.6996 6.59218 3.55297 5.0732 5.07198C3.55423 6.59099 2.70088 8.65121 2.70088 10.7994C2.70088 12.9476 3.55423 15.0079 5.0732 16.5269C6.59218 18.0459 8.65235 18.8992 10.8005 18.8992V18.8992Z"
                  fill="#777777"
                />
              </svg>
            </div>
            {/* flex item2 */}
            {/* notification icon */}
            <div>
              <svg
                width="46"
                height="46"
                viewBox="0 0 46 46"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="col-span-5"
              >
                <rect width="46" height="46" rx="23" fill="#F4F3F6" />
                <path
                  d="M22.6739 32.8681C22.0578 32.7785 21.4757 32.5299 20.9848 32.147C20.7896 32.0193 20.6259 31.8489 20.5062 31.6488C20.3864 31.4486 20.3137 31.2238 20.2934 30.9914C20.2934 30.4975 20.7478 30.2605 21.1725 30.1617C22.4877 30.0649 23.8082 30.0649 25.1234 30.1617C25.5481 30.2605 26.0025 30.4877 26.0025 30.9914C25.9841 31.2231 25.9132 31.4476 25.7951 31.6478C25.677 31.8481 25.5149 32.0188 25.321 32.147C24.8275 32.5319 24.2417 32.7806 23.6221 32.8681C23.4576 32.8782 23.2927 32.8782 23.1282 32.8681C22.9769 32.8764 22.8252 32.8764 22.6739 32.8681ZM18.5056 28.6999C17.4128 28.6009 16.394 28.1055 15.6412 27.3072C15.0852 26.6508 14.7837 25.8165 14.7917 24.9563C14.7419 24.1328 14.9988 23.32 15.5128 22.6747C15.8732 22.3039 16.1524 21.8621 16.3327 21.3774C16.513 20.8927 16.5903 20.3758 16.5598 19.8596V19.4349C16.4958 18.0528 16.9502 16.6967 17.8339 15.6321C18.4852 14.8555 19.2981 14.2304 20.216 13.8005C21.1338 13.3706 22.1344 13.1462 23.148 13.1431H23.2368C24.273 13.1443 25.2956 13.3784 26.2291 13.828C27.1626 14.2777 27.9831 14.9314 28.6299 15.7408C29.4654 16.7848 29.8873 18.0998 29.8152 19.4349V19.8596C29.7913 20.3735 29.8699 20.887 30.0462 21.3703C30.2225 21.8535 30.4932 22.2969 30.8424 22.6747C31.3547 23.3209 31.6114 24.1331 31.5635 24.9563C31.5715 25.8165 31.27 26.6508 30.714 27.3072C29.9612 28.1055 28.9424 28.6009 27.8496 28.6999C26.2988 28.8381 24.7382 28.9468 23.1677 28.9468C21.6103 28.9525 20.0538 28.87 18.5056 28.6999Z"
                  fill="#7D8CAC"
                />
              </svg>
            </div>
          </div>
          {/* flex item 3 */}
          <p className="">John Smith</p>
        </div>
      </div>
    </>
  );
};

export default Header;
